/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Custom_ToolsInputs */

const en_svchip_custom_tools = /** @type {(inputs: Svchip_Custom_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom tools`)
};

const ar_svchip_custom_tools = /** @type {(inputs: Svchip_Custom_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أدوات مخصصة`)
};

const bn_svchip_custom_tools = /** @type {(inputs: Svchip_Custom_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কাস্টম টুল`)
};

const de_svchip_custom_tools = /** @type {(inputs: Svchip_Custom_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzerdefinierte Werkzeuge`)
};

const es_svchip_custom_tools = /** @type {(inputs: Svchip_Custom_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herramientas personalizadas`)
};

const fr_svchip_custom_tools = /** @type {(inputs: Svchip_Custom_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outils personnalisés`)
};

const pt_svchip_custom_tools = /** @type {(inputs: Svchip_Custom_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ferramentas personalizadas`)
};

const zh_svchip_custom_tools = /** @type {(inputs: Svchip_Custom_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自定义工具`)
};

const tr_svchip_custom_tools = /** @type {(inputs: Svchip_Custom_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Özel araçlar`)
};

const ru_svchip_custom_tools = /** @type {(inputs: Svchip_Custom_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пользовательские инструменты`)
};

const pl_svchip_custom_tools = /** @type {(inputs: Svchip_Custom_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Narzędzia niestandardowe`)
};

/**
* | output |
* | --- |
* | "Custom tools" |
*
* @param {Svchip_Custom_ToolsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_custom_tools = /** @type {((inputs?: Svchip_Custom_ToolsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Custom_ToolsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_custom_tools(inputs)
	if (locale === "bn") return bn_svchip_custom_tools(inputs)
	if (locale === "de") return de_svchip_custom_tools(inputs)
	if (locale === "es") return es_svchip_custom_tools(inputs)
	if (locale === "fr") return fr_svchip_custom_tools(inputs)
	if (locale === "pt") return pt_svchip_custom_tools(inputs)
	if (locale === "zh") return zh_svchip_custom_tools(inputs)
	if (locale === "tr") return tr_svchip_custom_tools(inputs)
	if (locale === "ru") return ru_svchip_custom_tools(inputs)
	if (locale === "pl") return pl_svchip_custom_tools(inputs)
	return en_svchip_custom_tools(inputs)
});